












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CollectionTable, { TableHeader } from "@/components/CollectionTable.vue";
import { firestore } from "firebase/app";

type Manufacturer = { name: string };

@Component({ components: { CollectionTable } })
export default class Manufacturers extends Vue {
  readonly headers: TableHeader<Manufacturer>[] = [
    {
      text: "ID",
      value: "id",
      sortable: false,
      class: "idCol"
    },
    {
      text: "Name",
      value: "name",
      sortable: true
    }
  ];

  readonly dbRef = firestore().collection("manufacturers");
}
